import { useCallback, useEffect } from 'react';

const useScrollToTop = () => {
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  return scrollToTop;
};

// Hook for automatic scroll to top on component mount
const useAutoScrollToTop = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
};

export { useScrollToTop, useAutoScrollToTop };
export default useScrollToTop; 